import { roundToFixed } from 'utils/roundToFix';
import { BetType } from '../types';
import { EMPTY_BET } from '../data';

type GetDoubleBetPropsType = {
  placedBets: BetType;
};

type GetDoubleBetReturnType = {
  doubledBets: BetType;
};

export const getDoubleBet = ({ placedBets }: GetDoubleBetPropsType): GetDoubleBetReturnType => {
  const result: GetDoubleBetReturnType = Object.entries(placedBets).reduce(
    ({ doubledBets }: GetDoubleBetReturnType, [slotName, placedValue]) => {
      const doubledSlotValue = placedValue * 2;

      return {
        doubledBets: {
          ...doubledBets,
          [slotName]: roundToFixed(doubledSlotValue, 2),
        },
      };
    },
    {
      doubledBets: { ...EMPTY_BET },
    },
  );

  return result;
};
